export default __webpack_public_path__ + "static/media/CRISTI_CALINA.c4bceb96.jpg";